import { useEffect, useRef } from "react";

// Drives the boot splash that public/index.html paints before the bundle
// loads: once `ready` is true (and the logo's intro has had time to play) the
// chip spins out, the backdrop fades, and the app fades in underneath.
// Timings match the CSS in public/index.html.

const INTRO_MS = 420;       // logo fade/scale in
const SPIN_OUT_MS = 1400;   // spin + shrink + fade
const BACKDROP_DELAY_MS = 1000; // backdrop starts fading this far into the spin
const MAX_WAIT_MS = 4000;   // never hold the app back longer than this
const ENTRANCE_MS = 1200;   // card rise-ins, after which tab switches are instant

let played = false; // once per page load (StrictMode runs effects twice in dev)

function playExit() {
  if (played) return;
  played = true;
  const splash = document.getElementById("boot-splash");
  const body = document.body;
  if (!splash) {
    body.classList.remove("tp-booting");
    body.classList.add("tp-entered");
    return;
  }
  splash.classList.add("is-leaving");
  // Reveal the app as the backdrop starts to dissolve; the card rise-ins
  // (paused while booting) play from here.
  setTimeout(() => body.classList.remove("tp-booting"), BACKDROP_DELAY_MS);
  setTimeout(() => splash.remove(), SPIN_OUT_MS + 120);
  setTimeout(() => body.classList.add("tp-entered"), BACKDROP_DELAY_MS + ENTRANCE_MS);
}

export function useBootSplash(ready) {
  const mountedAt = useRef(performance.now());

  useEffect(() => {
    const t = setTimeout(playExit, MAX_WAIT_MS);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!ready || played) return undefined;
    const wait = Math.max(0, INTRO_MS - (performance.now() - mountedAt.current));
    const t = setTimeout(playExit, wait);
    return () => clearTimeout(t);
  }, [ready]);
}
